export default {
  errorSolicitud: false,
  msgErrorSolicitud: '',
  tituloNewslatter: '',
  descripcionNewslatter: '',
}
